import { Fragment, useEffect, useRef, useCallback, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";

//i18n
import { withTranslation } from "react-i18next";
import useAuthUser from "../../common/hooks/authUser";
import { withRouter } from "../Common";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const { isAdmin, isDealer } = useAuthUser();

  const menu = useMemo(
    () =>
      isAdmin ? (
        <>
          <Link to="/dashboard">
            <i className="far fa-chart-bar" />
            <span>{props.t("Dashboard")}</span>
          </Link>

          <Link to="/machines">
            <i className="fas fa-snowplow" />
            <span>{props.t("Machines")}</span>
          </Link>

          <Link to="/admin/warranty-registration">
            <i className="fas fa-clipboard-check" />
            <span>{props.t("Register Warranty")}</span>
          </Link>

          <Link to="/admin/dealer-inventory">
            <i className="fas fa-warehouse" />
            <span>{props.t("Dealer inventory")}</span>
          </Link>

          <Link to="/admin/documoto-parts">
            <i className="fas fa-book" />
            <span>{props.t("Parts manuals search")}</span>
          </Link>

          <Link to="/users">
            <i className="fas fa-users" />
            <span>{props.t("Operators")}</span>
          </Link>

          <Link to="/quotes">
            <i className="fas fa-file-invoice-dollar" />
            <span>{props.t("Quotes")}</span>
          </Link>

          <Link to="/jobs">
            <i className="fas fa-briefcase" />
            <span>{props.t("Jobs")}</span>
          </Link>

          <Link to="/work-sessions">
            <i className="fas fa-helmet-safety" />
            <span>{props.t("Work Sessions")}</span>
          </Link>
        </>
      ) : isDealer ? (
        <>
          <Link to="/dashboard">
            <i className="far fa-chart-bar" />
            <span>{props.t("Dashboard")}</span>
          </Link>

          <Link to="/machines">
            <i className="fas fa-snowplow" />
            <span>{props.t("Dealer Machines")}</span>
          </Link>

          <Link to="/admin/warranty-registration">
            <i className="fas fa-clipboard-check" />
            <span>{props.t("Register Warranty")}</span>
          </Link>
        </>
      ) : (
        <>
          <Link to="/dashboard">
            <i className="far fa-chart-bar" />
            <span>{props.t("Dashboard")}</span>
          </Link>

          <Link to="/machines">
            <i className="fas fa-snowplow" />
            <span>{props.t("My Machines")}</span>
          </Link>
        </>
      ),
    [isAdmin, isDealer, props.t]
  );

  return (
    <Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>{menu}</li>
          </ul>
        </div>
      </SimpleBar>
    </Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
